module.exports = __webpack_public_path__ + "launched-app-white.svg?845f53dbf30bc81d5738ea92b4c55d4d";